import React, { useContext, useEffect, useState, useRef } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartSeries,
     ChartLegend,
     ChartSeriesItem,
     ChartCategoryAxis,
     ChartCategoryAxisItem,
} from "@progress/kendo-react-charts";
import { Context } from "../../../../_context/Store";
import { useSelector,useDispatch } from "react-redux";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import {
     timeFormatUtcToLocal,
     getObjectFromArray,
     getDateRangeString,
     showCustomLoading,
} from "../../../../_helpers/support.services";
import ExportToExcelWithApi from "../../../_uiComponents/common/ExportToExcelWithApi";
import  {getEmailDispatchDownloadRequest} from "../../../../_redux/_actions"
import { dashboardConstants } from "../../../../_redux/_constants";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";

export default function EmailDespatches(props) {
     const [state, dispatch] = useContext(Context);
     const actionDispatch = useDispatch();
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);

     const { loader } = useSelector((state) => {
          return {
               loader: state.loading,
          };
     }); 

     const [exportData, setExportData] = useState(null);
     const downloadFileName = useRef(null);

     const getData = (startDate = null, endDate = null) => {
          downloadFileName.current =
               "email_dispatch_summary_" +
               getObjectFromArray(
                    props.applicationId,
                    "value",
                    dashboardConstants.userTypes,
               ).label +
               "_date_" +
               getDateRangeString(startDate, endDate);

          props.getData(startDate, endDate, props.applicationId);
     };

     useEffect(
          function () {
               getData(startDate, endDate);
          },
          [props.applicationId],
     );

     const {
          dashboardEmailDispatchSummary,
          dashBoardEmailDespatchesWithColor,
          dashboardEmailDispatchDownload
     } = useSelector((state) => {
          return {
               dashboardEmailDispatchSummary:
                    state.dashboard.dashboardEmailDispatchSummary,
               dashBoardEmailDespatchesWithColor:
                    state.dashboard.dashboardEmailDispatchSummary?.chartDataList.map(
                         (item, index) => ({
                              name: item.name,
                              value: item.values,
                         }),
                    ),
               dashboardEmailDispatchDownload:state.dashboard.dashboardEmailDispatchDownload
          };
     });

       useEffect(()=>{
          setExportData(dashboardEmailDispatchDownload)
     },[dashboardEmailDispatchDownload])

     const fetchDataForExport = async (onDownloadComplete) => {
          try {
          actionDispatch(getEmailDispatchDownloadRequest({
                    downloadType:"emaildispatch",
                    startDate,
                    endDate,
                    applicationId:props.applicationId
               }));
          } catch (error) {
               onDownloadComplete(false);
               console.error("Error fetching data for export:", error);
          }
     };

     return (
          <>
               <div className="sba-chart-top-section sba-db-email-despatches">
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}
                    <h5>Email Despatches</h5>

                    <ExportToExcelWithApi 
                              name={downloadFileName.current}
                              data={exportData}
                              onDownloadClick={(onDownloadComplete) => fetchDataForExport(onDownloadComplete)}
                         />

                    <div className="sba-chart-top-range-picker">
                         <UiDateRangePicker
                              maxDateCount={30}
                              maxDate={true}
                              onChange={(value) => {
                                   if (value[0] && value[1]) {
                                        const startDate = timeFormatUtcToLocal(
                                             value[0],
                                        );
                                        const endDate = timeFormatUtcToLocal(
                                             value[1],
                                        );
                                        setStartDate(startDate);
                                        setEndDate(endDate);

                                        getData(startDate, endDate);
                                   } else {
                                        if (!value[0] && !value[1]) {
                                             getData();
                                        }
                                   }
                              }}
                         />
                    </div>
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>
               <div
                    className={
                         state.ui_sidebar_open === true
                              ? "collapse-chart"
                              : "expand-chart"
                    }
               >
                    <Chart
                         transitions={false}
                         style={{
                              width: "100%",
                              height: "100%",
                              position: "center center",
                         }}
                    >
                         <ChartLegend
                              position="bottom"
                              orientation="horizontal"
                         />
                         <ChartCategoryAxis>
                              <ChartCategoryAxisItem
                                   labels={{
                                        rotation: "auto",
                                   }}
                                   categories={
                                        dashboardEmailDispatchSummary?.categories
                                   }
                              />
                         </ChartCategoryAxis>

                         <ChartSeries>
                              {dashBoardEmailDespatchesWithColor?.map(
                                   (item, idx) => (
                                        <ChartSeriesItem
                                             key={idx}
                                             // color={item.color}
                                             type="column"
                                             tooltip={{
                                                  visible: true,
                                             }}
                                             data={item.value}
                                             name={item.name}
                                        />
                                   ),
                              )}
                         </ChartSeries>
                    </Chart>
               </div>
          </>
     );
}
